/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomResourceMappingDetails {
    getFixupPrototypeFunction() { return AppSecopsSbomResourceMappingDetails.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomResourceMappingDetails>): AppSecopsSbomResourceMappingDetails {
        let obj = Object.assign(new AppSecopsSbomResourceMappingDetails(), model);
        AppSecopsSbomResourceMappingDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomResourceMappingDetails>): AppSecopsSbomResourceMappingDetails {
        if (!model) return null;
        return AppSecopsSbomResourceMappingDetails.newInstance(<AppSecopsSbomResourceMappingDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomResourceMappingDetails) {
        if (!obj) return;

        models.AppSecopsSbomResourceMappingDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomResourceMappingDetails): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomResourceMappingDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.last_mapped_at === "string") {
            this.last_mapped_at = new Date(<string><any>this.last_mapped_at);
        }
        if (this.background_job_id) {
            models.RecordIdentity.fixupPrototype(this.background_job_id);
        }
        if (this.mapped_resources) {
            for (let val of this.mapped_resources) {
                models.AppSecopsMappedResource.fixupPrototype(val);
            }
        }
    }

    mapped_resources: Array<models.AppSecopsMappedResource>;

    /**
     * Status of Resource Mapping
     */
    status: models.AppSecopsSbomResourceMappingStatus;

    /**
     * Message of Resource Mapping
     */
    message: string;

    /**
     * The most recent date and time of automated resource mapping to the SBOM.
     */
    last_mapped_at: Date;

    /**
     * Id of background job which performs the mapping of resources to SBOM.
     */
    background_job_id: models.RecordIdentity;

}
